module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./cfg/slot-config.js
// module id = 20
// module chunks = 0